import { Component, OnInit } from '@angular/core';
import {FormBuilder, FormGroup, Validators} from "@angular/forms";
import {ColumnApi, GridApi} from "ag-grid-community";
import {HttpControllers} from "../../../../utils/Class/HttpController";
import {DATA_SOURCE} from "../../../../../environments/environment";
import {HttpClient} from "@angular/common/http";
import {BehaviorSubject, Observable, Subscription} from "rxjs";
import {ApiResponse} from "../../../../model/interfaces/response";
import {ExcelServiceService} from "../../../portal-compras/services/excel-service.service";
import { UtilsService } from 'src/app/shared/utils/utils.service';
import {map, switchMap} from "rxjs/operators";
import {moduloConciliacion} from "../../diccionarios/constRecaudo"
import { AG_GRID_LOCALE_ES } from "../../../../utils/ag-grid-es";
import {DatosMaestrosService} from "../../../../services/datos-maestros.service";
import {CentroLogistico} from "../../../../model/datos-maestros/centroLogistico";
import {RecaudoBancarioService} from "../../services/recaudoBancario/recaudo-bancario.service";
import {StadardCode, rptConciliacionTotal} from "../../models/recuadosBancario/ParamExtracionBanca";

export interface reporteConciliacionTotal {
  transferencias:     number;
  depositos:          number;
  transfer_num:       number;
  depositos_num:      number;
}

export interface reporteConciliacion {
  fechaCobro: string;
  idCliente: string;
  nombreCliente: string;
  idVendedor: string;
  nombreVendedor: string;
  idCobro: string;
  consecutivo: number;
  fechaDocumento: string;
  idTipoPago: number;
  tipoPago: string;
  numeroDocumento: string;
  monto: number;
  tipoDocContable: string;
  docContable: string;
  facturaPedido: string;
  idDivision: string;
  division: string;
  bancoCliente: string;
  bancoClienteDescripcion: string;
  bancoDestino: string;
  bancoDestinoDescripcion: string;
  mensaje: string;
  estadoCobroVdi: string;
  estadoBloqueo: number;
  fechaConfirmaSap: string;
  idEmpresa : string;
  idFlete: string;
  idBancoExtracto: string;
  descripcionBancoExtracto: string;
  cuentaBancaria: string;
  fechaExtracto: string;
  fechaContable: string;
  numeroExtracto: string;
  numeroReferencia: string;
  montoExtracto: number;
  tipoMovimiento: string;
  estadoExtracto: string;
  documentoDupliacado: string;
  txtMotivo: string; //T.23147.sn
  txtInfor: string;
  txtOtros: string;
  bloqueoPxA: string;
  estatusPxA: string;
  fechaHoraAutorizaPxA: string;
  numOrden: string;
}

@Component({
  selector: 'app-reporte-concilia-extrato-recuado',
  templateUrl: './reporte-concilia-extrato-recuado.component.html',
  styleUrls: ['./reporte-concilia-extrato-recuado.component.css']
})
export class ReporteConciliaExtratoRecuadoComponent implements OnInit {
  newOrExisting: string = "1";
  styleRadio1: string;
  styleRadio2: string;
  formulario: FormGroup;
  PANTALLA_ACTUAL : number = 0;
  PANTALLA_1 : number = 1;
  PANTALLA_2 : number = 2;
  disablebutton: boolean = false;
  l10nAgGrid = AG_GRID_LOCALE_ES;
  columnDefsConciliacion: any;
  public moduloConciliacion = moduloConciliacion;
  centers: CentroLogistico[] = [];
  cmbEstados : StadardCode[] = [];

  public searchParamkardex: Observable<reporteConciliacion[]> = new BehaviorSubject(null);
  public dataSourceKardex$ :Observable<ApiResponse<reporteConciliacion[]>> ;
  public dataSourceEstado$ :Observable<ApiResponse<StadardCode[]>>;
  private subscriptionOP: Subscription;

  public searchParamkardexTotal: Observable<reporteConciliacionTotal[]> = new BehaviorSubject(null);
  public dataSourceKardexTotal$ :Observable<ApiResponse<reporteConciliacionTotal[]>> ;


  gridApik: GridApi;
  gridColumnApik: ColumnApi;

  totals?: rptConciliacionTotal

  constructor(private httpClient: HttpClient,
              public fb : FormBuilder,
              public excelService: ExcelServiceService,
              private _utils: UtilsService,
              private readonly maestrosService: DatosMaestrosService,
              private _recaudoservice: RecaudoBancarioService) {
  }

  ngOnInit(): void {
    this.formulario = this.fb.group({
      division : ['', [Validators.required]],
      fechadesde : ['', [Validators.required]],
      fechahasta : ['', [Validators.required]],
      fechasapdesde : ['',],
      fechasaphasta : ['',],
      idCliente : ['', ],
      idRecaudador: ['', ],
      estadoSync: ['', ],
    });
    const $this = this;
    this.columnDefsConciliacion = [
      { field: "idVendedor", headerName: "ID Recaudador", filter: true, sortable: true, width: 150 },
      { field: "nombreVendedor", headerName: "Nombre Recaudador", filter: true, sortable: true, width: 200 },
      { field: "idCliente", headerName: "ID Cliente", filter: true, sortable: true, width: 150 },
      { field: "nombreCliente", headerName: "Nombre Cliente", filter: true, sortable: true, width: 200 },
      { field: "fechaCobro", headerName: "Fecha Cobro", filter: true, sortable: true, width: 150 },
      { field: "idCobro", headerName: "ID Cobro", filter: true, sortable: true, width: 150 },
      { field: "consecutivo", headerName: "Consecutivo", filter: true, sortable: true, width: 120 },
      { field: "fechaDocumento", headerName: "Fecha Documento", filter: true, sortable: true, width: 150,
        valueGetter: function (data) {
          return $this._utils.getFormatoFecha(data.data.fechaDocumento)
        }},
      { field: "idTipoPago", headerName: "ID Tipo Pago", filter: true, sortable: true, width: 120 },
      { field: "tipoPago", headerName: "Tipo Pago", filter: true, sortable: true, width: 180 },
      { field: "numeroDocumento", headerName: "Número Documento", filter: true, sortable: true, width: 150 },
      { field: "facturaPedido", headerName: "Factura/Pedido", filter: true, sortable: true, width: 150 },
      { field: "monto", headerName: "Monto", filter: true, sortable: true, width: 120 },
      { field: "tipoDocContable", headerName: "Tipo Doc Contable", filter: true, sortable: true, width: 150 },
      { field: "docContable", headerName: "Documento Contable", filter: true, sortable: true, width: 150 },
      { field: "fechaConfirmaSap", headerName: "Fecha Sap", filter: true, sortable: true, width: 150 },
      { field: "idDivision", headerName: "ID División", filter: true, sortable: true, width: 120 },
      { field: "division", headerName: "División", filter: true, sortable: true, width: 200 },
      //{ field: "bancoCliente", headerName: "Banco Cliente", filter: true, sortable: true, width: 150 },
      { field: "bancoClienteDescripcion", headerName: "Banco Cliente", filter: true, sortable: true, width: 150 },
      { field: "bancoDestino", headerName: "Banco Destino", filter: true, sortable: true, width: 150 },
      { field: "bancoDestinoDescripcion", headerName: "Banco Destino Nombre", filter: true, sortable: true, width: 150 },
      { field: "idFlete", headerName: "Orden Flete", filter: true, sortable: true, width: 150 },
      { field: "mensaje", headerName: "Mensaje", filter: true, sortable: true, width: 250 },
      { field: "estadoCobroVdi", headerName: "Estado Cobro VDI", filter: true, sortable: true, width: 150 },
      { field: "documentoDupliacado", headerName: "Doc. Duplicado", filter: true, sortable: true, width: 150 },
      { field: "idBancoExtracto", headerName: "ID Banco Extracto", filter: true, sortable: true, width: 150 },
      { field: "descripcionBancoExtracto", headerName: "Banco Extracto", filter: true, sortable: true, width: 150 },
      { field: "cuentaBancaria", headerName: "Cuenta Bancaria", filter: true, sortable: true, width: 150 },
      { field: "fechaExtracto", headerName: "Fecha Extracto", filter: true, sortable: true, width: 150,
        valueGetter: function (data) {
          return $this._utils.getFormatoFecha(data.data.fechaExtracto)
        }},
      { field: "fechaContable", headerName: "Fecha Contable", filter: true, sortable: true, width: 150,
        valueGetter: function (data) {
          return $this._utils.getFormatoFecha(data.data.fechaContable)
        }},
      { field: "numeroExtracto", headerName: "Número Extracto", filter: true, sortable: true, width: 150 },
      { field: "numeroReferencia", headerName: "Número Referencia", filter: true, sortable: true, width: 150 },
      { field: "montoExtracto", headerName: "Monto Extracto", filter: true, sortable: true, width: 120 },
      { field: "tipoMovimiento", headerName: "Tipo Movimiento", filter: true, sortable: true, width: 120,
        valueGetter: function (data) {
          let codigo = data.data.tipoMovimiento;
          return $this._recaudoservice.getTiposMovimientos().find(x => x.codigo == codigo)?.descripcion;
        }
      },
      { field: "txtMotivo", headerName: "Motivo Rechazo", filter: true, sortable: true, width: 150 },
      { field: "txtInfor", headerName: "Informacion 1 del rechazo", filter: true, sortable: true, width: 150 },
      { field: "txtOtros", headerName: "Informacion 2 del rechazo", filter: true, sortable: true, width: 150 },
      { field: "bloqueoPxA", headerName: "Bloqueo Pedido PxA", filter: true, sortable: true, width: 50 },
      { field: "estatusPxA", headerName: "Estatus sustento PxA", filter: true, sortable: true, width: 50 },
      { field: "numOrden", headerName: "Num Orden", filter: true, sortable: true, width: 50 },
    ];

    this.maestrosService.getAllCentroLogistico().subscribe((res) => {
      this.centers = res;
      this.centers.unshift({idCentro: "0", nombreCentro: "Todos",ciudad: "", direccionCentro: "", status: false });
      this.formulario.get('division').setValue("0");
    });

    this.setEstados();

  }

  onGridReadyk(params) {
    this.gridColumnApik = params.columnApi;
    this.gridApik = params.api;
  }

  callReporteMDI() {
    console.log(this.newOrExisting);
    this.onSelectNew();
    this.fillGridkardex();
    this.disablebutton = this.formulario.invalid;
  }

  onSelectNew(){
    console.log(" as "+ this.newOrExisting);
    if(this.newOrExisting == "1"){
      this.styleRadio1 = "active";
      this.styleRadio2 = "";
      this.PANTALLA_ACTUAL = this.PANTALLA_1;
      this.disablebutton = false;
    } else if(this.newOrExisting == "2"){
      this.styleRadio1 = "";
      this.styleRadio2 = "active";
      this.PANTALLA_ACTUAL = this.PANTALLA_2;
      this.disablebutton = this.formulario.invalid;
    }
    console.log(" tp "+ this.PANTALLA_ACTUAL);
    console.log('es frmulario ->' + this.formulario.valid);
    console.log('es Variable 2->' + this.disablebutton);
  }

  exportAsExcel(filename?: string): void {

      this.excelService.exportToExcel(this.gridApik, {
        fileName: 'ReporteConciliacion'+this._utils.getCurrentDateGuion()+'.xlsx',
        sheetName: 'Conciliacion Recaudos',
        columns : [
          {
            header: 'ID Recaudador',
            key: 'idVendedor',
            width: 20
          },
          {
            header: 'Nombre Recaudador',
            key: 'nombreVendedor',
            width: 40
          },
          {
            header: 'ID Cliente',
            key: 'idCliente',
            width: 20
          },
          {
            header: 'Nombre Cliente',
            key: 'nombreCliente',
            width: 50
          },
          {
            header: 'Fecha Cobro',
            key: 'fechaCobro',
            width: 15
          },
          {
            header: 'ID Cobro',
            key: 'idCobro',
            width: 30
          },
          {
            header: 'Consecutivo',
            key: 'consecutivo',
            width: 15
          },
          {
            header: 'Fecha Documento',
            key: 'fechaDocumento',
            width: 20
          },
          {
            header: 'ID Tipo Pago',
            key: 'idTipoPago',
            width: 20
          },
          {
            header: 'Tipo Pago',
            key: 'tipoPago',
            width: 30
          },
          {
            header: 'Número Documento',
            key: 'numeroDocumento',
            width: 20
          },
          {
            header: 'Factura/Pedido',
            key: 'facturaPedido',
            width: 40
          },
          {
            header: 'Monto',
            key: 'monto',
            width: 15
          },
          {
            header: 'Tipo Doc Contable',
            key: 'tipoDocContable',
            width: 25
          },
          {
            header: 'Documento Contable',
            key: 'docContable',
            width: 25
          },
          {
            header: 'Fecha Sap',
            key: 'fechaConfirmaSap',
            width: 25
          },
          {
            header: 'ID División',
            key: 'idDivision',
            width: 20
          },
          {
            header: 'División',
            key: 'division',
            width: 50
          },
          /*{
            header: 'Banco Cliente',
            key: 'bancoCliente',
            width: 25
          },*/
          {
            header: 'Banco Cliente',
            key: 'bancoClienteDescripcion',
            width: 25
          },
          {
            header: 'Banco Destino',
            key: 'bancoDestino',
            width: 25
          },
          {
            header: 'Banco Destino Nombre',
            key: 'bancoDestinoDescripcion',
            width: 25
          },
          {
            header: 'Orden Flete',
            key: 'idFlete',
            width: 25
          },
          {
            header: 'Mensaje',
            key: 'mensaje',
            width: 50
          },
          {
            header: 'Estado Cobro VDI',
            key: 'estadoCobroVdi',
            width: 25
          },
          {
            header: 'Doc. Duplicado',
            key: 'documentoDupliacado',
            width: 25
          },
          {
            header: 'ID Banco Extracto',
            key: 'idBancoExtracto',
            width: 25
          },
          {
            header: 'Banco Extracto',
            key: 'descripcionBancoExtracto',
            width: 25
          },
          {
            header: 'Cuenta Bancaria',
            key: 'cuentaBancaria',
            width: 30
          },
          {
            header: 'Fecha Extracto',
            key: 'fechaExtracto',
            width: 20
          },
          {
            header: 'Fecha Contable',
            key: 'fechaContable',
            width: 20
          },
          {
            header: 'Número Extracto',
            key: 'numeroExtracto',
            width: 20
          },
          {
            header: 'Número Referencia',
            key: 'numeroReferencia',
            width: 25
          },
          {
            header: 'Monto Extracto',
            key: 'montoExtracto',
            width: 15
          },
          {
            header: 'Tipo Movimiento',
            key: 'tipoMovimiento',
            width: 18,
            valueGetter: (row) => this.getTiposMovimientos( row.tipoMovimiento)
          },
          {
            header: 'Estado Extracto',
            key: 'estadoExtracto',
            width: 25
          }
          //T.23147.sn
          ,{
            header: 'Motivo Rechazo',
            key: 'txtMotivo',
            width: 30
          },
          ,{
            header: 'Fecha Rechazo',
            key: 'fechaHoraRechazo',
            width: 25
          },
          {
            header: 'Informacion 1 del rechazo',
            key: 'txtInfor',
            width: 50
          },
          {
            header: 'Informacion 2 del rechazo',
            key: 'txtOtros',
            width: 50
          },
          {
            header: 'Bloqueo Pedido PxA',
            key: 'bloqueoPxA',
            width: 30
          },
          {
            header: 'Estatus sustento PxA',
            key: 'estatusPxA',
            width: 30
          },
          {
            header: 'Fecha autoriza PxA',
            key: 'fechaHoraAutorizaPxA',
            width: 30
          },
          {
            header: 'Num.Orden',
            key: 'numOrden',
            width: 30
          },
          {
            header: 'Dato Original VDI',
            key: 'dataOriginalVdi',
            width: 80
          },
          {
            header: 'Fecha reemp. VDI',
            key: 'dataVdiFechaHoraActualiza',
            width: 30
          },
          {
            header: 'Extracto dupl.',
            key: 'extractoDuplicado',
            width: 30
          },
          {
            header: 'Identificacion Ordenante',
            key: 'identificacionOrdenante',
            width: 25
          },
          {
            header: 'Nombre Ordenante',
            key: 'nombreOrdenante',
            width:100
          },
        ]
      });

  }


  fillGridkardex() {
    const fechaDesde = this.formulario.get('fechadesde').value; //this._utils.getFechaInput(this.formulario.get('fechadesde').value);
    const fechaHasta = this.formulario.get('fechahasta').value; //this._utils.getFechaInput(this.formulario.get('fechahasta').value); //this.formulario.get('fechahasta').value;
    const estado = this.formulario.get('estadoSync').value === null || this.formulario.get('estadoSync').value === undefined ? 99 : this.formulario.get('estadoSync').value;
    console.log("estado ",estado);
    const params = {
      ...(this.formulario.get('division').value && { division: this.formulario.get('division').value }),
      ...(this.formulario.get('fechadesde').value && { fechadesde: this.formulario.get('fechadesde').value }),
      ...(this.formulario.get('fechahasta').value && { fechahasta: this.formulario.get('fechahasta').value }),
      ...(this.formulario.get('fechasapdesde').value && { fechasapdesde: this.formulario.get('fechasapdesde').value }),
      ...(this.formulario.get('fechasaphasta').value && { fechasaphasta: this.formulario.get('fechasaphasta').value }),
      ...(this.formulario.get('idCliente').value && { idCliente: this.formulario.get('idCliente').value }),
      ...(this.formulario.get('idRecaudador').value && { idRecaudador: this.formulario.get('idRecaudador').value }),
      estadoSync: estado,
    };

    //const mensaje = `La fecha desde es: ${fechaDesde} y la fecha hasta es: ${fechaHasta}`;
    //console.log(mensaje)
    ///path: 'cobros/reporteConciliacion?fechaDesde=' + fechaDesde + '&fechaHasta=' + fechaHasta,
    this.dataSourceKardex$ = this.searchParamkardex.pipe(
      switchMap((data: reporteConciliacion[]) => {
        return new HttpControllers<reporteConciliacion>(this.httpClient)
          .read<reporteConciliacion[]>({
            datasource: DATA_SOURCE.FINANCIERO,
            path: 'cobros/reporteConciliacion',
            queryParams: params
          });
      })
    );
     //Para sacar los totales
      this.getTotals(params);
  }

  getTotals(params: any) {
    this._recaudoservice.getTotales(params)
      .subscribe((res) => this.totals = res.respuesta)
  }

  validforms(){
    this.disablebutton = this.formulario.invalid;
    console.log("onchange "+this.disablebutton);
  }


  getTiposMovimientos(data) {
    const  descrip = this._recaudoservice.getTiposMovimientos().find(x => x.codigo == data);
    if (descrip) {
      return descrip.descripcion;
    }else {
      return '';
    }

  }

  setEstados() {
    this.dataSourceEstado$ = this._recaudoservice.cargaEstadosCobrosVdi();

    this.subscriptionOP = this.dataSourceEstado$.subscribe((resp: ApiResponse<StadardCode[]>) => {
      this.cmbEstados = [{ codigo: 99, descripcion: 'Todos' , display: '99 | Todos'}, ...resp.respuesta.filter(x => x.codigo !== 3)];
      this.formulario.get('estadoSync').setValue(99);
    }, (error) => {
      this.cmbEstados = [];
      console.log(error);
    });
  }


  LimpiarFormulario() {
    this.formulario.reset();
    this.formulario.get('division').setValue("0");
    this.formulario.get('estadoSync').setValue(99);
  }

}
